(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moonsmc-signature-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mm-hero-photo-picker')) {
    customElements.define('mm-hero-photo-picker', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.photos = [...this.querySelectorAll('[data-slide]')];
        if (!this.photos.length) return;
        this.controller = new AbortController();
        this.request = (this.request || 0) + 1;
        this.addEventListener('shopify:block:select', event => {
          const index = this.photos.findIndex(photo => photo.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.show(index);
        }, { signal: this.controller.signal });
        let index = 0;
        if (this.selectedId) {
          index = Math.max(0, this.photos.findIndex(photo => photo.dataset.blockId === this.selectedId));
        } else if (this.dataset.editor !== 'true' && this.photos.length > 1) {
          try {
            const previous = sessionStorage.getItem(this.dataset.storageKey);
            const lastIndex = this.photos.findIndex(photo => photo.dataset.blockId === previous);
            index = (lastIndex + 1) % this.photos.length;
          } catch {
            index = Math.floor(Math.random() * this.photos.length);
          }
        }
        this.show(index);
      }

      disconnectedCallback() {
        this.request = (this.request || 0) + 1;
        this.controller?.abort();
        this.controller = null;
      }

      async show(index) {
        const controller = this.controller;
        const request = ++this.request;
        const image = this.photos[index].querySelector('img');
        if (image) {
          image.loading = 'eager';
          image.fetchPriority = 'high';
          try { await image.decode(); } catch { return; }
        }
        if (!this.controller || controller !== this.controller || request !== this.request) return;
        this.photos.forEach((photo, position) => {
          photo.hidden = position !== index;
          photo.setAttribute('aria-hidden', String(position !== index));
        });
        this.selectedId = this.photos[index].dataset.blockId;
        this.dataset.photoReady = 'true';
        if (this.dataset.editor !== 'true' && this.selectedId) {
          try { sessionStorage.setItem(this.dataset.storageKey, this.selectedId); } catch {}
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
